<template lang="pug">
  tbody.message-area
    tr.data_row
      td.openclosetd
        .openclosebutton(@click='show_hide_row')
      td
        label {{data.title}}
      td
        label {{data.client_name}}<br>{{data.client_mail}}
      td
        label(v-html='inquiryDate')
      td.center
        label {{data.total}}&nbsp;件
      td.center
        label(v-if='data.status == 1') 未対応
        label(v-if='data.status == 2') 対応中
        label(v-if='data.status == 3') 対応済
        label(v-if='data.status == 90') 対応不要
      td.center
        label {{data.user_name}}
      td.tags
        label {{data.strTag}}
    tr.hidden_row
      td.messagedetail(colspan='8')
        p ※各項目が入力・変更後、リアルタイムで保存されます
        hr
        .row
          .col-xs-6
            // inquiryのtitleカラムを使用、変更可能
            label.pull-left 件名
            input.title.form-control(type='text' v-model='data.title')
          .col-xs-6
            label 送信元&nbsp;&nbsp;{{data.client_name}}&nbsp;({{data.client_mail}})
        .row
          .col-xs-12
            // inquiryのdata(json形式)カラムを使用、1回目の問い合わせ内容から不変
            label 内容
            pre
              div.list-box(v-for='(json, data_index) in data.data')
                div.data-caption {{json.caption}}&nbsp;:&nbsp;
                div.data-value {{json.value}}
        .row
          .col-xs-6
            label.taglabel タグ
            input.typeahead(type='text' data-role='tagsinput' v-model='data.strTag')
          .col-xs-6
            label 備考
            textarea.remarks(rows='3' v-model='data.remark')
        .row
          .col-xs-12
            label 状況
            select.searchselect.selectitems(v-model='data.status')
              option(value='1') 未対応
              option(value='2') 対応中
              option(value='3') 対応済
              option(value='90') 対応不要
            label 担当者
            select.searchselect.selectitems(v-model='data.user_id' name='user')
              option(value='null') ---
              option(v-for='member in members' v-bind:value='member.id') {{member.name}}
        .row
          .col-xs-12
            button.customsmallbutton.btn.btn-success(data-action='open' data-side='right' type='button' name='chat' @click='showHistory') 履歴表示
            button.customsmallbutton.btn.btn-info(type='button' @click='print') 印&nbsp;刷
            button.customsmallbutton.btn.deletebutton.btn.btn-danger(type='button' @click='delInquiry') 削&nbsp;除
</template>

<script>
import $ from 'jquery'
import _ from 'underscore'
import bus from '@/service/EventBus'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'

export default {
  props: ['data', 'members', 'tags'],
  name: 'message',
  data () {
    return {
      row: this.data
    }
  },
  computed: {
    inquiryDate: function () {
      let splitedDate = this.data.created_at.split(' ')
      return splitedDate[0] + '<br>' + splitedDate[1]
    }
  },
  mounted () {
    let vue = this

    // タグのオートコンプリート
    $('[data-role=tagsinput]').tagsinput({
      typeahead: {
        displayKey: 'text',
        source: function () {
          return vue.tags
        }
      }
    })

    // tags input の add, remove function
    $('[data-role=tagsinput]').on('itemAdded', function (event) {
      let inquiryId = $(this).parents('tbody').attr('id')
      let tags = $(this).val().split(',')  // カンマ区切りで取得できるので、splitして配列にする
      // タグに1つでも50文字以上のものがあればなにもしない
      for (let key in tags) {
        if (tags[key].length > 50) {
          return false
        }
      }
      vue.inquiryTagsUpdate(inquiryId, tags)
    })
    $('[data-role=tagsinput]').on('itemRemoved', function (event) {
      let inquiryId = $(this).parents('tbody').attr('id')
      let tags = $(this).val().split(',')  // カンマ区切りで取得できるので、splitして配列にする
      vue.inquiryTagsUpdate(inquiryId, tags)
    })
  },
  created () {
    // 各項目をwatchして登録する
    this.$watch('data.title', function (val) {
      let datas = {'title': val}
      this.inquiryUpdate(this.data.id, datas)
    })
    this.$watch('data.remark', function (val) {
      let datas = {'remark': val}
      this.inquiryUpdate(this.data.id, datas)
    })
    this.$watch('data.status', function (val) {
      let datas = {'status': val}
      this.inquiryUpdate(this.data.id, datas)
    })
    this.$watch('data.user_id', function (val) {
      let datas = []
      if (val === 'null') { // nullは文字列
        datas = {'user_id': '', 'user_name': ''}
      } else {
        let user = _.findWhere(this.members, {id: val})
        datas = {'user_id': val, 'user_name': user.name}
      }
      this.inquiryUpdate(this.data.id, datas)
    })
  },
  methods: {
    // 履歴表示ボタン、右に画面を表示し、MessageHistory.vueにinquiry_idを送る
    showHistory () {
      let inquiryId = this.data.id
      bus.$emit('inquiry_id', inquiryId)
      $('.sidebar.right').sidebar({side: 'right'})
      $('.sidebar.right').css('display', '')  // sidebarのdisplay:noneを解除
      $('.sidebar.right').trigger('sidebar:open')
      // sidebar open event
      $('.sidebar.right').on('sidebar:opened', function () {
        $('.btn[data-action=open]').hide()
      })
      // sidebar close event
      $('.sidebar.right').on('sidebar:closed', function () {
        $('.btn[data-action=open]').show()
      })
    },
    inquiryUpdate: function (id, datas) {
      // 更新
      let axios = Request.instance(true)
      let currentUser = this.$store.user.name
      axios.put('/message/' + id + '/update',
        qs.stringify({
          datas: JSON.stringify(datas),
          user: JSON.stringify(currentUser)
        })
      ).then((res) => {
        this.data.user_name = res.data.user_name
      }).catch((error) => {
        // dashboardへメッセージを送信
        Message.error(error.response.data.message)
      })
    },
    inquiryTagsUpdate (id, tags) {  // タグの更新（登録、削除）
      // 更新対象のデータを保持しておく
      let targetRow = _.findWhere(this.$parent.disp_inquirys, {id: id})
      // 更新
      let axios = Request.instance(true)
      axios.put('/message/' + id + '/tags',
        qs.stringify({
          datas: JSON.stringify(tags)  // 更新対象の行のtagのみ送る
        })
      ).then((res) => {
        targetRow.strTag = res.data.join(',')
        $('tbody#' + id).find('tr.data_row').find('td.tags').find('label').text(res.data.join(','))
        // Message.show('success', [message])
      }).catch((error) => {
        // dashboardへメッセージを送信
        Message.error(error.response.data.message)
      })
    },
    delInquiry () { // 問い合わせ削除
      let inquiryId = this.data.id
      let self = this
      $.confirm({
        title: '',
        content: '問い合わせを削除しますか？',
        columnClass: 'col-md-2 col-md-offset-5',
        type: 'dark',
        typeAnimated: true,
        buttons: {
          はい: {
            btnClass: 'btn-dark',
            action: function () {
              self.$nextTick(() => { Loader.show() })
              Request.create(true).delete('/message/' + self.$route.params.id + '/' + inquiryId)
                .then((res) => {
                  // Message.success('問い合わせを削除しました')
                  self.$parent.bind()
                }).catch((err) => {
                  Message.error(err.response.data.message)
                  self.$nextTick(() => { Loader.hide() })
                })
            }
          },
          いいえ: function () {
          }
        }
      })
    },
    // 行の展開・折りたたみ
    show_hide_row () {
      let target = $(event.target).parents('tr').next()
      // 該当行にアクションする
      $(event.target).toggleClass('clicked')
      target.toggle()
    },
    // 印刷ボタン
    print: function (event) {
      let inquiryId = $(event.target).parents('tbody').attr('id')
      let protocol = location.protocol
      // let host = location.host.split(':')
      // let url = protocol + '//' + host[0] + ':9000' // portを書き換える
      let url = protocol + '//' + 'racooo.com' // portを書き換える
// // TODO URLなおす
      window.open(url + '/message/' + inquiryId + '/print')
    }
  }
}
</script>

<style lang="stylus" scoped>
.datatable
  thead
    background-color: #EEE
  tbody> tr> td
    border-bottom: 1px solid #ddd
    border-left: 1px solid #ddd
    border-right: 1px solid #ddd
  tbody> tr
    background-color: #FFF
  tbody+ tbody
    border: none
  td.center
    text-align: center
  td
    word-break: break-all
    border-top: none !important
  .openclose
    width: 3%
  .name
    width: 20%
  .sender
    width: 20%
  .time
    width: 10%
  .history
    width: 7%
  .states
    width: 10%
  .charge
    width: 10%
  .tagtitle
    width: 20%
  .row
    margin: 10px
  .hidden_row
    display: none
  textarea
    padding: 0
    width: 20%
  .taglabel
    vertical-align: top
  .messagedetail
    textarea
      resize: vertical
    .contens
      width: 100%
    .title
      width: 90%
      border-radius: 3px
    .remarks
      width: 90%
      padding: 5px 0px 0px 10px
    .list-box
      display: table
    .data-caption
      width: 120px
    .data-value
      display: table-cell
      vartical-align: middle
  .selectitems
    margin-right: 30px
  label
    margin-right: 5px
  pre
    white-space: pre-wrap

.messageboxcontents
  .customsmallbutton
    margin-left: 5px
    padding: 6px 10px
    font-size: 14px
  .deletebutton
    float: right
.chatbutton
  border-radius: 50px
  border: 1px solid #FFFFF
.tdcenter
  text-align: center
#readingmessage
  color: #FFF

//開閉ボタン(messageboxのみで適用)
.openclosetd
  width: 3%
.openclosebutton
  width: 30px
  height: 30px
  background: #26B99A
  top: 50%
  left: 50%
  transform: translate(0%, 0%) rotate(0deg)
  border-radius: 50%
  cursor: pointer
  z-index: 100
  transition: 0.4s cubic-bezier(0.2, 0.6, 0.3, 1.1)
  &:after
    content: ''
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    height: 2px
    width: 50%
    background: white
  &:before
    content: ''
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    height: 50%
    width: 2px
    background: white
  &.clicked
    transform: translate(0%, 0%) rotate(360deg)
    background: #CC2A41
    &:before
      width: 0
</style>




// WEBPACK FOOTER //
// Message.vue?2004f5a5